module.exports = __webpack_public_path__ + "static/media/jugendservice_logo.9b5e8424.png";